"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var messages = (0, _reactIntl.defineMessages)({
  cookiePreferences: {
    "id": "cookiePreferences",
    "defaultMessage": "Cookie preferences"
  },
  useOfCookies: {
    "id": "useOfCookies",
    "defaultMessage": "We use cookies for the purposes described below. Approved third parties also use cookies for limited tracking purposes described below. We apply your cookie preferences to this SwipeGuide service (website and app version)."
  },
  acceptAllCookies: {
    "id": "acceptAllCookies",
    "defaultMessage": "Accept all cookies"
  },
  requiredCookies: {
    "id": "requiredCookies",
    "defaultMessage": "Required cookies"
  },
  firstForRequiredCookies: {
    "id": "firstForRequiredCookies",
    "defaultMessage": "These are cookies that are essential for the operation of our platform and cannot be deactivated on our systems. They enable you to move around our website and use our features."
  },
  useForRequiredCookies: {
    "id": "useForRequiredCookies",
    "defaultMessage": "We use cookies to provide our services, for example:"
  },
  recognizeAuthentication: {
    "id": "recognizeAuthentication",
    "defaultMessage": "Recognize you when you authenticate to use our services."
  },
  preventFraudulentActivity: {
    "id": "preventFraudulentActivity",
    "defaultMessage": "Prevent fraudulent activity."
  },
  improveSafety: {
    "id": "improveSafety",
    "defaultMessage": "Improve safety"
  },
  track: {
    "id": "track",
    "defaultMessage": "Track anonymous platform adoption and usage."
  },
  customerSupportService: {
    "id": "customerSupportService",
    "defaultMessage": "Allow you to use customer support service."
  },
  otherCookies: {
    "id": "otherCookies",
    "defaultMessage": "Other cookies"
  },
  otherCookiesDescription: {
    "id": "otherCookiesDesription",
    "defaultMessage": "We also use cookies to understand how customers use our services so that we can make improvements. Some of the cookies that we use come from third parties, which are used for web analysis. These companies use cookies to collect information about your interactions with our website and/or application, such as the pages you visit, the links you click on and the time spent on our website. For more information about how these companies collect and process your information, please refer to their own privacy policies."
  },
  savePreferences: {
    "id": "savePreferences",
    "defaultMessage": "Save preferences"
  },
  changePreferences: {
    "id": "changePreferences",
    "defaultMessage": "You can change your cookie preferences any time by returning here through the {privacyPage}. You can read more about cookies and how we use them in our {cookie}."
  },
  on: {
    "id": "on",
    "defaultMessage": "On"
  },
  off: {
    "id": "off",
    "defaultMessage": "Off"
  },
  privacyPage: {
    "id": "privacyPage",
    "defaultMessage": "Privacy page"
  },
  cookiePolicy: {
    "id": "cookiePolicy",
    "defaultMessage": "Cookie policy"
  }
});
var _default = exports["default"] = messages;
//# sourceMappingURL=messages.js.map